import { Box, Text } from '@factorialco/deprecated-design-system'

import { Card } from './types'

type Props = {
  card: Card
}

export const Alias = ({ card }: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Text.Normal size="200">{card.alias}</Text.Normal>
    </Box>
  )
}
